import React from "react";

/** Loading placeholders for the two metric cards. They reuse the real cards'
 *  structure (`vb-dcard` / `vb-expo` / `vb-big5` / `vb-mini-stats`) so the
 *  skeleton occupies the same footprint and reflows the same way on desktop and
 *  mobile as the filled card — only the data is swapped for `vb-skel` bones.
 *  Static labels are kept (they don't load) so the cards read as themselves. */

/** AI Trust Signal exposure — donut + headline + description. */
export function ExposureCardSkeleton() {
  return (
    <div className="vb-dcard" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading AI Trust Signal exposure…</span>
      <div className="vb-dcard__hd">
        <span className="vb-dcard__lbl">AI Trust Signal exposure</span>
      </div>
      <div className="vb-expo">
        <div className="vb-ring-wrap">
          <span className="vb-skel vb-skel-donut" aria-hidden="true" />
          <span className="vb-ring-cap">Exposed</span>
        </div>
        <div className="vb-expo-skel" aria-hidden="true">
          <span className="vb-skel vb-skel-line vb-skel-line--title" style={{ width: "78%" }} />
          <span className="vb-skel vb-skel-line" style={{ width: "96%" }} />
          <span className="vb-skel vb-skel-line" style={{ width: "64%" }} />
        </div>
      </div>
    </div>
  );
}

/** Big 5 coverage — 5 category tiles + the 3 mini-stats footer. */
export function Big5CoverageCardSkeleton() {
  return (
    <div className="vb-dcard" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading Big 5 coverage…</span>
      <div className="vb-dcard__hd">
        <span className="vb-dcard__lbl">Big 5 coverage</span>
      </div>

      <div className="vb-big5" aria-hidden="true">
        {Array.from({ length: 5 }).map((_, i) => (
          <div className="vb-b5" key={i}>
            <div className="vb-b5__hd">
              <span className="vb-skel vb-skel-chip-ico" />
              <span className="vb-skel vb-skel-line" style={{ width: "62%" }} />
            </div>
            <div className="vb-b5__ct">
              <span className="vb-skel vb-skel-line" style={{ width: 34 }} />
            </div>
          </div>
        ))}
      </div>

      <div className="vb-mini-stats" aria-hidden="true">
        {Array.from({ length: 3 }).map((_, i) => (
          <div className="vb-ms" key={i}>
            <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: 64 }} />
            <span className="vb-skel vb-skel-line vb-skel-line--title" style={{ width: 52 }} />
          </div>
        ))}
      </div>
    </div>
  );
}
